import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=e11db7a2&scoped=true&"
import script from "./v-button.vue?vue&type=script&lang=js&"
export * from "./v-button.vue?vue&type=script&lang=js&"
import style0 from "./v-button.vue?vue&type=style&index=0&id=e11db7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11db7a2",
  null
  
)

export default component.exports